import React, { useEffect } from "react";
import { CheckCircle2 } from "lucide-react";

const ModalReceiverConfirmData = ({
  isOpenReceiverConfirmData,
  showSuccessScreenReceiverConfirmData,
  closeModalReceiverConfirmData,
  selectedNegotiationReceiverConfirmData,
  actionTypeReceiverConfirmData,
  handleSubmit,
  loadingReceiverConfirmData,
  errorReceiverConfirmData,
  successReceiverConfirmData,
}) => {
  const isConfirm = actionTypeReceiverConfirmData === "confirm";
  const actionLabel = isConfirm
    ? "Confirmar Disponibilidade"
    : "Recusar Disponibilidade";

  useEffect(() => {
    if (isOpenReceiverConfirmData) {
      document.documentElement.style.overflow = "hidden";
    } else {
      document.documentElement.style.overflow = "auto";
      document.body.style.overflow = "unset";
    }

    return () => {
      document.documentElement.style.overflow = "auto";
      document.body.style.overflow = "unset";
    };
  }, [isOpenReceiverConfirmData]);

  if (!isOpenReceiverConfirmData) return null;

  return (
    <div
      className="modal-overlay"
      onClick={closeModalReceiverConfirmData}
      style={{
        alignItems: "flex-start",
        overflowY: "auto",
        padding: "20px 12px",
      }}
    >
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        style={{
          height: "auto",
          maxHeight: "none",
          margin: "auto",
        }}
      >
        <div className="modal-header">
          <h2>
            {isConfirm
              ? "Confirmar Disponibilidade"
              : "Recusar Disponibilidade"}
          </h2>
        </div>

        <div className="modal-body">
          {showSuccessScreenReceiverConfirmData ? (
            <div className="receiver-success-container">
              <CheckCircle2 size={90} className="receiver-success-icon" />

              <h3 style={{ marginBottom: -5 }}>Ação realizada com sucesso</h3>

              <p>{successReceiverConfirmData}</p>

              <button
                onClick={closeModalReceiverConfirmData}
                className="action-btn ghost"
              >
                Entendi
              </button>
            </div>
          ) : (
            <>
              {selectedNegotiationReceiverConfirmData?.trip && (
                <p style={{ marginBottom: 12 }}>
                  <strong>Viagem:</strong>{" "}
                  {selectedNegotiationReceiverConfirmData.trip?.cidade_origem ||
                    selectedNegotiationReceiverConfirmData.trip?.de}{" "}
                  →{" "}
                  {selectedNegotiationReceiverConfirmData.trip
                    ?.cidade_destino ||
                    selectedNegotiationReceiverConfirmData.trip?.para}
                </p>
              )}

              <div
                className={`receiver-confirm-box ${
                  isConfirm ? "confirm-mode" : "reject-mode"
                }`}
              >
                <div className="receiver-confirm-icon">
                  {isConfirm ? "✅" : "⚠️"}
                </div>

                <div className="receiver-confirm-content">
                  <h3>
                    {isConfirm
                      ? "Confirmar disponibilidade"
                      : "Recusar disponibilidade"}
                  </h3>

                  <p>
                    {isConfirm
                      ? "Deseja confirmar que você está disponível para receber esta encomenda?"
                      : "Deseja recusar a sua disponibilidade para receber esta encomenda?"}
                  </p>
                </div>
              </div>

              {errorReceiverConfirmData && (
                <div className="modal-error">{errorReceiverConfirmData}</div>
              )}

              <div className="modal-actions">
                <button
                  type="button"
                  className="action-btn ghost"
                  onClick={closeModalReceiverConfirmData}
                  disabled={loadingReceiverConfirmData}
                >
                  Cancelar
                </button>

                <button
                  type="button"
                  className="action-btn save-modal"
                  onClick={handleSubmit}
                  disabled={loadingReceiverConfirmData}
                >
                  {loadingReceiverConfirmData ? "Processando..." : actionLabel}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalReceiverConfirmData;
